import layout from './layout'
import enums from './enums'
import uiLanguages from './uiLanguages'

import broadcasts from './broadcasts'
import countries from './countries'
import crons from './crons'
import epgSources from './epgSources'
import epgs from './epgs'
import episodes from './episodes'
import images from './images'
import imageSizes from './imageSizes'
import labels from './labels'
import languages from './languages'
import pairingTemplates from './pairingTemplates'
import settings from './settings'
import shows from './shows'
import tvChannels from './tvChannels'
import tvStationGroups from './tvStationGroups'
import tvStations from './tvStations'
import users from './users'
import videoQualities from './videoQualities'
import currencies from './vod/currencies'
import providers from './vod/providers'
import packages from './vod/packages'
import videos from './vod/videos'
import backoffices from './backoffices'
import blackoutContents from './blackoutContents'
import blackoutContentTemplates from '@/store/modules/blackoutContentTemplates'
import maturityRatings from './maturityRatings'

export default {
  layout,
  enums,
  uiLanguages,
  broadcasts,
  countries,
  crons,
  epgSources,
  epgs,
  episodes,
  images,
  imageSizes,
  labels,
  languages,
  pairingTemplates,
  settings,
  shows,
  tvChannels,
  tvStationGroups,
  tvStations,
  users,
  videoQualities,
  currencies,
  providers,
  videos,
  packages,
  backoffices,
  blackoutContents,
  blackoutContentTemplates,
  maturityRatings
}
